const registerLocalize = {
    "errorCadastro": "Não foi possível salvar, tente novamente!",

};

export default registerLocalize;